import { Class, mixins, define,  mixinRules, extendable } from './class.ts'
import { Record } from './record/index.ts'
//import { Model } from './model.ts'
//import { Collection } from './collection'
import * as tools from './tools.ts'

export {
    Class, define, mixins, mixinRules, extendable,
    Record,
    //Model,
    //Collection,
    tools
}; 


/** WEBPACK FOOTER **
 ** ./src/index.ts
 **/